import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { RouterModule, Routes } from '@angular/router';

import { HashLocationStrategy, LocationStrategy, APP_BASE_HREF  } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { LotesComponent } from './lotes/lotes.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { GalponesComponent } from './galpones/galpones.component';
import { CorralesComponent } from './corrales/corrales.component';
import { AgregarCorralComponent } from './agregar-corral/agregar-corral.component';
import { AgregarPesoComponent } from './agregar-peso/agregar-peso.component';
import { PesajesComponent } from './pesajes/pesajes.component';
import { SemanaComponent } from './semana/semana.component';
import { LoginComponent } from './login/login.component';

const appRoutes: Routes = [
    { path: 'galpones', component: GalponesComponent },
    { path: 'lotes/:idgalpon"', component: LotesComponent },
    { path: 'lotes', component: LotesComponent },
    { path: 'corrales/:idlote"', component: CorralesComponent },
    { path: 'corrales', component: CorralesComponent },
    { path: 'agregar-corral', component: AgregarCorralComponent },
    { path: 'agregar-corral/:idlote', component: AgregarCorralComponent },
    { path: 'pesajes/:idcorral"', component: PesajesComponent },
    { path: 'pesajes', component: PesajesComponent },
    { path: 'semanas/:idsemana"', component: SemanaComponent },
    { path: '', component: LoginComponent },
    { path: 'agregar-peso', component: AgregarPesoComponent },
    { path: 'agregar-peso/:icorral', component: AgregarPesoComponent },
    { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    LotesComponent,
    PageNotFoundComponent,
    GalponesComponent,
    CorralesComponent,
    AgregarCorralComponent,
    AgregarPesoComponent,
    PesajesComponent,
    SemanaComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    FormsModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    HttpClientModule,
    RouterModule.forRoot(
     appRoutes,
     { enableTracing: true } // <-- debugging purposes only
   )],
  providers: [
      {provide : APP_BASE_HREF , useClass: HashLocationStrategy, useValue: '/delphuspoultry/'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
